import { render } from "./controlActivityLevel.vue?vue&type=template&id=627104d6&ts=true"
import script from "./controlActivityLevel.vue?vue&type=script&lang=ts"
export * from "./controlActivityLevel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__